/** API route map: URLS.Controller.ClientPayrollTaxOverride */
export const ClientPayrollTaxOverride = {
      Name: 'ClientPayrollOverride/',
      GetAll: 'guests',
      Add: 'add',
      Update: 'update',
      Delete: 'delete',
};
